import { useEffect, useState } from "react";
import { Client, PublicClient, clientService } from "../services/client.service";

export function useClient(clientId?: string, isPublic?: boolean) {
    const [client, setClient] = useState<Client | PublicClient | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchClient = async () => {
        if (!clientId) return;
        setIsLoading(true);
        setError(null);

        try {
            const data = isPublic
                ? await clientService.getPublicById(clientId)
                : await clientService.getById(clientId);
            setClient(data);
        } catch (e: any) {
            setError(e?.message || "Erreur lors du chargement");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchClient();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientId]);

    return {
        client,
        isLoading,
        error,
        refetch: fetchClient,
    };
}
